import FinanceApi from '@/services/FinanceApi';
import Api from "@/services/Index";

const numberOfStudents = async (config) => {
    return FinanceApi.get('/reports/number-of-students', config);
}

const collection = async (config) => {
    return FinanceApi.get('/reports/collection', config);
}

const studentCollection = async (config) => {
    return FinanceApi.get('/reports/student-collection', config);
}

const cashCollection = async (config) => {
    return FinanceApi.get('/reports/cash-collection', config);
}

const pilotage = async (config={}) => {
    return FinanceApi.get('/payment/plans/pilotage/report', config);
}

const balance = async (config) => {
    return FinanceApi.get('/reports/balance', config);
}

const educationCredits = async (config) => {
    return FinanceApi.get('/reports/education-credits', config);
}

const earlyPayment = async (config) => {
    return FinanceApi.get('/reports/early-payment', config);
}

const graduateFullScholarshipRatio = async (config) => {
    return FinanceApi.get('/reports/graduate-full-scholarship-ratio', config);
}

const agingSummaryReport = async (config) => {

    return FinanceApi.get('/payment/plans/aging-summary-report',config);

}
const collectionReport = async (config) => {
    return FinanceApi.get('/payment/plans/collection-report',config);
}

const financeReconciliation  = async (config) => {
    return FinanceApi.get(`/payments/bank-reconciliation-report`, config);
}

const cashFlowReport = async (config) => {
    return FinanceApi.get('/payment/plans/cash-flow-report',config);
}


export default {
    numberOfStudents,
    collection,
    cashCollection,
    pilotage,
    studentCollection,
    balance,
    educationCredits,
    earlyPayment,
    graduateFullScholarshipRatio,
    agingSummaryReport,
    collectionReport,
    financeReconciliation,
    cashFlowReport
}
